import { TFunction } from 'i18next';
import { getOnpremHostname } from 'omni-package-react-core';
import { WidgetOptions } from 'aw-package-react-signin-widget';
import Configuration from '../../../utils/Configuration';
import { getLanguage } from '../../../utils/getLanguage';

export function getSignInConfiguration(t: TFunction, disableSignUp?: Boolean): WidgetOptions {
  const config = Configuration.Current();
  const lang = getLanguage();
  const loginError = t('loginError');
  const mfaChoiceButton = t('mfaChoiceButton');
  const mandatoryMessage = t('mandatoryMessage');
  const back = t('back');
  const onPremHostName = getOnpremHostname();
  return {
    baseUrl: config.idpTenantUrl,
    language: lang,
    i18n: {
      [lang]: {
        'primaryauth.username.placeholder': t('username'),
        'errors.E0000004': loginError,
        'errors.E0000069': loginError,
        'errors.E0000047': loginError,
        remember: t('remember'),
        'primaryauth.submit': t('signInButton'),
        'registration.signup.text': t('signUpButton'),
        'enroll.choices.setup': mfaChoiceButton,
        'enroll.choices.submit.configure': mfaChoiceButton,
        'enroll.choices.description.generic': t('mfaChoiceDescription'),
        'factor.totpSoft.description': t('mfaGoogleChoiceDescription'),
        'factor.push.description': t('mfaOktaVerifyChoiceDescription'),
        signout: back,
        'mfa.backToFactors': back,
        'password.expired.custom.submit': t('passwordExpiredSubmit'),
        'password.expired.custom.subtitle': t('passwordExpiredSubtitle'),
        'error.username.required': mandatoryMessage,
        'error.password.required': mandatoryMessage,
        forgotpassword: t('forgotPassword'),
        'oform.errorbanner.title': t('oform.errorbanner.title'),
        'factor.call.description': t('factor.call.description'),
        'enroll.totp.setupGoogleAuthApp': t('enroll.totp.setupGoogleAuthApp'),
        'enroll.totp.cannotScan': t('enroll.totp.cannotScan'),
        'enroll.totp.cannotScanBarcode': t('enroll.totp.cannotScanBarcode'),
        'enroll.totp.manualSetupInstructions': t('enroll.totp.manualSetupInstructions'),
        'enroll.totp.enterCode': t('enroll.totp.enterCode'),
        'mfa.challenge.enterCode.placeholder': t('mfa.challenge.enterCode.placeholder'),
        'mfa.challenge.enterCode.tooltip': t('mfa.challenge.enterCode.tooltip'),
        'phone.extention.label': t('phone.extention.label'),
        'mfa.phoneNumber.ext.placeholder': t('mfa.phoneNumber.ext.placeholder'),
        'factor.sms.description': t('factor.sms.description'),
        'factor.sms.time.warning': t('factor.sms.time.warning'),
        'factor.call.time.warning': t('factor.call.time.warning'),
        'enroll.totp.setupApp': t('enroll.totp.setupApp'),
        'enroll.choices.optional': t('enroll.choices.optional'),
        'mfa.redial': t('mfa.redial'),
        'mfa.sendCode': t('mfa.sendCode'),
        'mfa.resendCode': t('mfa.resendCode'),
        'mfa.calling': t('mfa.calling'),
        'rememberDevice.timebased': t('rememberDevice.timebased'),
        'mfa.challenge.subtitle.call': t('mfa.challenge.subtitle.call'),
        'mfa.challenge.subtitle.sms': t('mfa.challenge.subtitle.sms'),
        'mfa.challenge.subtitle.email': t('mfa.challenge.subtitle.email'),
        'email.mfa.call.sent.description': t('email.mfa.call.sent.description'),
        'email.mfa.sms.sent.description': t('email.mfa.sms.sent.description'),
        'email.code.not.received': t('email.code.not.received'),
        'email.button.resend': t('email.button.resend'),
        'mfa.call': t('mfa.call'),
        'email.mfa.title': t('email.mfa.title'),
        'email.mfa.description': t('email.mfa.description'),
        'email.button.send': t('email.button.send'),
        'email.mfa.email.sent.description': t('email.mfa.email.sent.description'),
        'email.code.label': t('email.code.label'),
        'factor.email': t('factor.email'),
        'factor.sms': t('factor.sms'),
        'factor.call': t('factor.call'),
        'enroll.sms.setup': t('enroll.sms.setup'),
        'enroll.totp.title': t('enroll.totp.title'),
        'model.validation.field.blank': t('model.validation.field.blank'),
        'enroll.choices.list.enrolled': t('enroll.choices.list.enrolled'),
        'enroll.totp.sendSms': t('enroll.totp.sendSms'),
        'enroll.totp.sendEmail': t('enroll.totp.sendEmail'),
        'enroll.totp.setupManually': t('enroll.totp.setupManually'),
      },
    },
    helpLinks: {
      custom: [
        {
          text: t('forgotUsername'),
          href: `${onPremHostName}${config.forgetUserNamePath}`,
        },
        {
          text: t('cancel'),
          href: `${window.location.href}`,
        },
      ],
      forgotPassword: `${onPremHostName}${config.forgetPasswordPath}`,
    },
    registration: {
      click() {
        window.location.href = `${onPremHostName}${config.registrationPath}`;
      },
    },
    features: {
      customExpiredPassword: true,
      multiOptionalFactorEnroll: true,
      registration: !disableSignUp,
      showPasswordToggleOnSignInPage: true,
      selfServiceUnlock: false,
      webauthn: true,
      scrollOnError: false,
      idpDiscovery: config.useIdPDiscovery,
      router: config.featuresRouter,
    },
    useClassicEngine: config.useClassicEngine,
  };
}
